import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { ApplicationReviewService } from 'app/services/application-review/application-review.service';
import {of, tap} from 'rxjs';
import { AppReviewList, ApplicationReviewItem } from '../../../models/dto/borrower-fd/application-review.model';
import { GetApplicationReviewItems, UpdateKickback } from './application-review.actions';
import {catchError} from 'rxjs/operators';

export class ApplicationReviewStateModel {
  applicationReviewItems: ApplicationReviewItem[] = [];
  appReviewList: AppReviewList[] = [];
  loading: boolean = false;
}

@State<ApplicationReviewStateModel>({
  name: 'applicationReview',
  defaults: {
    applicationReviewItems: [],
    appReviewList: [],
    loading: false
  }
})

@Injectable()

export class ApplicationReviewState {

  @Selector()
	static kickback(state: ApplicationReviewStateModel) {
    return state.appReviewList;
  }

  @Selector()
	static applicationReviewItems(state: ApplicationReviewStateModel) {
    return state.applicationReviewItems;
  }

  @Selector()
  static loading(state: ApplicationReviewStateModel) {
    return state.loading;
  }

  constructor(
    private applicationReviewService: ApplicationReviewService
  ) {}

  @Action(UpdateKickback)
  update({patchState}: StateContext<ApplicationReviewStateModel>, {kickback}: UpdateKickback) {
    patchState({
      appReviewList: kickback
    });
  }

  @Action(GetApplicationReviewItems)
  getApplicationReviewItems({ patchState }: StateContext<ApplicationReviewStateModel>, {borrowerId}: GetApplicationReviewItems) {
    patchState({ loading: true });

    return this.applicationReviewService.getApplicationReviewItems(borrowerId)
      .pipe(
        tap(appReviewItems => {
          patchState({ applicationReviewItems: appReviewItems, loading: false });
        }),
        catchError( error => {
          console.error(error);
          return of();
        }),
      );
  }

}
